import React from 'react';

export default class CoverCard extends React.Component {
  render() {
    const story = this.props.story;
    return <img className='story-cover' src={story.coverUrl} width="128" alt={`${story.title} cover image`} />;
  }
}